import { useTranslation } from 'react-i18next';
import { Button } from '../components/Button';
import './Products.css';

export function Products() {
  const { t } = useTranslation();

  return (
    <section id="products" className="section">
      <div className="container">
        <div className="section-header">
          <span className="eyebrow">{t('products.eyebrow')}</span>
          <h2>{t('products.title')}</h2>
          <p>{t('products.subtitle')}</p>
        </div>

        <div className="products-grid">
          <article className="product-card">
            <div className="product-card__header">
              <span className="product-card__status">{t('products.meetflow.status')}</span>
              <span className="product-card__name">{t('products.meetflow.name')}</span>
            </div>
            <h3 className="product-card__tagline">{t('products.meetflow.tagline')}</h3>
            <p className="product-card__body">{t('products.meetflow.body')}</p>
            <div className="product-card__actions">
              <Button as="a" href="https://meetflow.ananeos.com" target="_blank" rel="noopener noreferrer" size="md">
                {t('products.meetflow.learnMore')}
              </Button>
              <Button as="a" href="https://meetflow.ananeos.com#waitlist" target="_blank" rel="noopener noreferrer" size="md" variant="ghost">
                {t('products.meetflow.joinWaitlist')}
              </Button>
            </div>
            <div className="product-card__mark" aria-hidden="true">
              <span className="product-card__orbit">
                <span className="product-card__dot" />
              </span>
            </div>
          </article>

          <article className="product-card product-card--placeholder">
            <div className="product-card__placeholder-icon" aria-hidden="true">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <h3 className="product-card__tagline">{t('products.next.title')}</h3>
            <p className="product-card__body">{t('products.next.body')}</p>
            <Button as="a" href="#newsletter" size="md" variant="ghost">
              {t('nav.newsletter')}
            </Button>
          </article>
        </div>
      </div>
    </section>
  );
}
